/** اندازه‌های مشترک — مستقل از تم. */

export const radius = { sm: 8, md: 12, lg: 14, xl: 20 } as const;

/** واحدِ پایه‌ی فاصله؛ `space(3)` یعنی ۱۲. */
export const space = (n: number): number => n * 4;

/**
 * فونت‌ها فقط سایت رو درگیر می‌کنن (اپ فونتِ خودش رو با expo-font بار می‌زنه)،
 * ولی چون بخشی از همون هویتِ بصری‌ان، جاشون کنارِ بقیه‌ی توکن‌هاست.
 */
export const fonts = {
  head: "'Fraunces', Georgia, serif",
  sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
} as const;
